import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const SITE_URL = 'https://www.rodekho.in';
const BRAND = 'RO Dekho';
const PHONE = '+91 9887068888';

const PAGE_MAP = {
  '/': 'home',
  '/about': 'about',
  '/team': 'about',
  '/services': 'services',
  '/contact': 'contact',
  '/faq': 'faq',
  '/privacy-policy': 'privacy',
  '/refund-policy': 'refund',
  '/terms-conditions': 'terms',
};

const SEO_DATA = {
  home: {
    title: "RO Water Purifier Repair Jaipur | RO Service, Installation & AMC | RO Dekho",
    description: "Jaipur's #1 RO water purifier repair, installation & AMC service. Same-day doorstep service across Mansarovar, Vaishali Nagar, Malviya Nagar, Jagatpura, C-Scheme & all 50+ localities. 30-min response, 90-day warranty. Call 9887068888.",
    keywords: "RO Water Purifier Jaipur, RO Water Purifier Repair Jaipur, RO Service Jaipur, RO Installation Jaipur, RO AMC Jaipur, RO Maintenance Jaipur, RO Repair Near Me Jaipur, Water Purifier Repair Jaipur, Water Filter Repair Jaipur, Domestic RO Repair Jaipur, Commercial RO Plant Repair Jaipur, Kent RO Repair Jaipur, Aquaguard Repair Jaipur, Livpure RO Repair Jaipur, Pureit RO Repair Jaipur, AO Smith RO Repair Jaipur, Best RO Repair Service in Jaipur, Same Day RO Repair Jaipur, 24 Hours RO Repair Jaipur, Doorstep RO Repair Jaipur, Emergency RO Repair Jaipur, RO Filter Change Jaipur, RO Membrane Replacement Jaipur, UV Water Purifier Repair Jaipur",
    schema: 'LocalBusiness'
  },
  about: {
    title: "About RO Dekho - Jaipur's Trusted Water Purifier Service Provider",
    description: "RO Dekho by Arpsan Lifestyle Technology Pvt Ltd - 10+ years of expert RO water purifier services in Jaipur. Certified technicians, genuine parts, 5000+ happy families.",
    keywords: "about RO Dekho, water purifier company Jaipur, Arpsan Lifestyle Technology, RO service provider Jaipur, trusted water purifier brand Jaipur",
    schema: 'AboutPage'
  },
  services: {
    title: "RO Water Purifier Services in Jaipur - Installation, Repair, AMC | RO Dekho",
    description: "Expert RO installation from ₹500, repair from ₹300, filter replacement, AMC plans & free water testing in Jaipur. Same-day service. Call +91 9887068888.",
    keywords: "RO installation Jaipur, RO repair service Jaipur, water purifier repair near me, RO service center Jaipur, RO AMC plan Jaipur, filter replacement Jaipur, water purifier maintenance Jaipur, emergency RO repair Jaipur",
    schema: 'Service'
  },
  contact: {
    title: "Contact RO Dekho - Book RO Service in Jaipur | Call +91 9887068888",
    description: "Book RO water purifier service in Jaipur. Call +91 9887068888, WhatsApp or fill the online form. Same-day service across Jaipur. Free home visit.",
    keywords: "contact RO Dekho, book RO service Jaipur, RO service phone number, water purifier helpline Jaipur, RO repair booking Jaipur",
    schema: 'ContactPage'
  },
  faq: {
    title: "FAQ - RO Water Purifier Service Questions | RO Dekho Jaipur",
    description: "Answers to common questions about RO water purifier service, repair costs, installation time, AMC plans, and water quality in Jaipur.",
    keywords: "RO service FAQ, water purifier questions, RO repair cost Jaipur, RO installation time, AMC plan details, water quality Jaipur",
    schema: 'FAQPage'
  },
  privacy: {
    title: "Privacy Policy - RO Dekho | Water Purifier Service Jaipur",
    description: "Read RO Dekho's privacy policy. Learn how we protect your personal information when you use our water purifier services.",
    keywords: "RO Dekho privacy policy, data protection",
    schema: 'WebPage'
  },
  refund: {
    title: "Refund Policy - RO Dekho | Water Purifier Service Jaipur",
    description: "Read RO Dekho's refund and cancellation policy for water purifier services and products purchased in Jaipur.",
    keywords: "RO Dekho refund policy, cancellation policy",
    schema: 'WebPage'
  },
  terms: {
    title: "Terms & Conditions - RO Dekho | Water Purifier Service Jaipur",
    description: "Terms and conditions for using RO Dekho's water purifier services and purchasing products in Jaipur.",
    keywords: "RO Dekho terms, conditions, service agreement",
    schema: 'WebPage'
  },
};

// Additional route-based SEO for pages not in PAGE_MAP
const ROUTE_SEO = {
  '/products': {
    title: "Buy RO Water Purifier Online in Jaipur - Best Prices | RO Dekho",
    description: "Buy genuine RO water purifiers from top brands at best prices in Jaipur. Kent, Aquaguard, Livpure & more. Free installation, 1 year warranty, COD available.",
    keywords: "buy RO water purifier Jaipur, water purifier price Jaipur, Kent RO Jaipur, Aquaguard Jaipur, best water purifier to buy, RO purifier online Jaipur, water purifier shop Jaipur, RO machine price"
  },
  '/spare-parts': {
    title: "RO Spare Parts & Filters in Jaipur - Genuine Parts | RO Dekho",
    description: "Buy genuine RO spare parts, filters, membranes & accessories in Jaipur. All brands available. Free installation with purchase. Call +91 9887068888.",
    keywords: "RO spare parts Jaipur, RO filter price, RO membrane Jaipur, water purifier parts, RO accessories, genuine RO parts Jaipur"
  },
  '/ro-on-rent': {
    title: "RO Water Purifier on Rent in Jaipur from ₹350/month | RO Dekho",
    description: "Rent a premium RO water purifier in Jaipur from just ₹350/month. Zero installation cost, free maintenance & filter changes. Best RO rental plans.",
    keywords: "RO on rent Jaipur, water purifier rental Jaipur, RO rent price, monthly RO rental, cheap RO rent Jaipur, water purifier on rent near me, RO rental plans Jaipur"
  },
  '/checkout': {
    title: "Checkout - RO Dekho | Secure Payment",
    description: "Complete your RO water purifier purchase securely. Pay online via UPI, card, net banking or choose Cash on Delivery.",
    keywords: "RO Dekho checkout, buy water purifier"
  },
  '/blog': {
    title: "Water Purification Blog - Tips & Guides | RO Dekho Jaipur",
    description: "Expert articles on water purification, RO maintenance tips, drinking water quality, and health benefits of pure water in Jaipur.",
    keywords: "water purification blog, RO maintenance tips, drinking water quality Jaipur, water purifier guide, RO care tips"
  },
  '/compare': {
    title: "Compare RO Water Purifiers - Find the Best | RO Dekho Jaipur",
    description: "Compare RO water purifier features, prices and specifications side by side. Find the best water purifier for your home in Jaipur.",
    keywords: "compare water purifiers, RO comparison, best RO for home Jaipur, water purifier comparison"
  },
  '/login': {
    title: "Login - RO Dekho | My Account",
    description: "Login to your RO Dekho account to track orders, manage bookings and view service history.",
    keywords: "RO Dekho login, my account"
  },
  '/account': {
    title: "My Account - RO Dekho | Orders & Bookings",
    description: "Manage your RO Dekho account, track orders, view booking history and manage delivery addresses.",
    keywords: "RO Dekho account, order history, booking history"
  }
};

const JAIPUR_LOCALITIES = [
  'Mansarovar', 'Vaishali Nagar', 'Malviya Nagar', 'Jagatpura', 'Pratap Nagar',
  'Sanganer', 'Tonk Road', 'Raja Park', 'Adarsh Nagar', 'C-Scheme', 'Civil Lines',
  'Bani Park', 'Shyam Nagar', 'Nirman Nagar', 'Gopalpura', 'Mahesh Nagar', 'Sodala',
  'Hasanpura', 'Ajmer Road', 'Sirsi Road', 'Jhotwara', 'Kalwar Road', 'Vidhyadhar Nagar',
  'Murlipura', 'Ambabari', 'Chandpole', 'MI Road', 'Pink City', 'Amer', 'Kanakpura',
  'Gandhi Path', 'Chitrakoot', 'Khatipura', 'VKI', 'Sitapura', 'Durgapura', 'Barkat Nagar',
  'Triveni Nagar', 'Patrakar Colony', 'Muhana', 'Iskcon Road', 'Shipra Path',
  'New Sanganer Road', 'Jawahar Nagar', 'Transport Nagar', 'Ramnagariya', 'Jagdamba Nagar',
  'Model Town', 'Bapu Nagar', 'Lal Kothi', 'Shastri Nagar', 'Vidhyut Nagar', 'Govindpura',
  'Harmada', 'Bhankrota', 'Mahapura', 'Bhambori'
];

const LOCAL_BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  '@id': `${SITE_URL}/#business`,
  name: BRAND,
  alternateName: 'RO Dekho - Water Purifier Service Center',
  description: "Jaipur's #1 RO water purifier repair, installation, AMC & rental service. Same-day doorstep service across 50+ localities of Jaipur.",
  url: SITE_URL,
  telephone: PHONE,
  email: 'support@rodekho.com',
  image: `${SITE_URL}/logo.png`,
  priceRange: '₹₹',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Main Tonk Road, Sector 3, Partap Nagar, Sanganer',
    addressLocality: 'Jaipur',
    addressRegion: 'Rajasthan',
    postalCode: '302033',
    addressCountry: 'IN'
  },
  geo: { '@type': 'GeoCoordinates', latitude: 26.8465, longitude: 75.8095 },
  openingHoursSpecification: [
    { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'], opens: '08:00', closes: '20:00' }
  ],
  aggregateRating: { '@type': 'AggregateRating', ratingValue: '4.9', reviewCount: '5000', bestRating: '5' },
  areaServed: [
    { '@type': 'City', name: 'Jaipur', '@id': 'https://www.wikidata.org/wiki/Q174461' },
    ...JAIPUR_LOCALITIES.map(name => ({ '@type': 'Place', name: `${name}, Jaipur` }))
  ],
  hasOfferCatalog: {
    '@type': 'OfferCatalog', name: 'RO Water Purifier Services',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'RO Installation', description: 'Professional RO water purifier installation in Jaipur. Free installation across all 50+ localities.' }},
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'RO Repair & Service', description: 'Same-day expert RO repair and maintenance service in Jaipur. 30-min response.' }},
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'RO AMC', description: 'Annual maintenance contract starting ₹1499 with 4 free services and filter replacements.' }},
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'RO on Rent', description: 'RO water purifier on rent in Jaipur from ₹350/month with free installation.' }},
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'RO Filter Replacement', description: 'Genuine sediment, carbon and RO membrane replacement for all brands in Jaipur.' }}
    ]
  },
  sameAs: [
    'https://www.facebook.com/rodekho',
    'https://www.instagram.com/rodekho'
  ]
};

function PageSEO() {
  const location = useLocation();
  const [seo, setSeo] = useState(null);
  const pathname = location.pathname;
  const pageId = PAGE_MAP[pathname];

  // Skip for pages that handle their own SEO
  const isBlogDetail = pathname.startsWith('/blog/') && pathname !== '/blog';
  const isDarbhanga = pathname === '/darbhanga';
  const isCityPage = pathname.startsWith('/city/');
  const isProductDetail = pathname.startsWith('/product/');
  const skipPageSEO = isBlogDetail || isDarbhanga || isCityPage || isProductDetail;

  useEffect(() => {
    if (!pageId || skipPageSEO) { setSeo(null); return; }
    fetch(`${BACKEND_URL}/api/cms/seo/${pageId}`)
      .then(r => r.ok ? r.json() : null)
      .then(data => setSeo(data))
      .catch(() => setSeo(null));
  }, [pageId, skipPageSEO]);

  if (skipPageSEO) return null;

  // Get SEO data from CMS override, PAGE_MAP defaults, or ROUTE_SEO
  const defaults = pageId ? (SEO_DATA[pageId] || {}) : (ROUTE_SEO[pathname] || {});
  const title = seo?.meta_title || defaults.title || `${BRAND} - Water Purifier Service Jaipur`;
  const description = seo?.meta_description || defaults.description || "Jaipur's most affordable water purifier service center. RO installation, repair, maintenance & rental.";
  const keywords = seo?.meta_keywords || defaults.keywords || 'RO water purifier Jaipur, water purifier service, RO repair Jaipur, RO Dekho';
  const canonical = seo?.canonical_url || `${SITE_URL}${pathname === '/' ? '' : pathname}`;
  const noIndex = seo?.no_index || false;
  const schemaType = seo?.schema_type || defaults.schema || 'WebPage';

  const pageSchema = {
    '@context': 'https://schema.org',
    '@type': schemaType,
    name: title,
    description: description,
    url: canonical,
  };

  const isHome = pathname === '/';

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {!noIndex && <meta name="robots" content="index, follow" />}

      {/* Geo tags for local SEO */}
      <meta name="geo.region" content="IN-RJ" />
      <meta name="geo.placename" content="Jaipur" />
      <meta name="geo.position" content="26.8465;75.8095" />
      <meta name="ICBM" content="26.8465, 75.8095" />

      {/* Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={isHome ? 'website' : 'article'} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:image" content={`${SITE_URL}/logo.png`} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />

      {/* Schema - Page */}
      <script type="application/ld+json">{JSON.stringify(pageSchema)}</script>

      {/* Schema - LocalBusiness (homepage only) */}
      {isHome && <script type="application/ld+json">{JSON.stringify(LOCAL_BUSINESS_SCHEMA)}</script>}
    </Helmet>
  );
}

export default PageSEO;
